import React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputWebsite = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Event website"), colon: false }, props.form.getFieldDecorator('website', {
    initialValue: props.initialValue || '',
    rules: [{
            max: 255,
            message: 'URL is too long',
        }, {
            type: 'url',
            message: 'This is not a valid URL (add http:// or https:// to the front)',
        }],
})(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: props.isDisabled })))); };
export default InputWebsite;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputWebsite.tsx
// module id = 1106
// module chunks = 0